import React from 'react';
import { Container, Typography, Box, Paper, Grid, Link, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function AboutPage() {
  // --- AUTOMATIC YEAR VARIABLE ---
  const currentYear = new Date().getFullYear();
  // -------------------------------

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Button 
        component={RouterLink} 
        to="/" 
        startIcon={<ArrowBackIcon />} 
        sx={{ mb: 2 }}
      >
        Back to Map
      </Button>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center" color="primary">
          About Christmas Lights Map {currentYear}
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
          Welcome to Australia's community-driven Christmas Lights Map! Our mission is simple: to help families find the joy of Christmas lights without driving around aimlessly.
        </Typography>

        <Typography variant="body1" paragraph>
          This platform is built for the community, by the community. Whether you have a massive synchronized light show or a beautiful static display, we want to help you share it with your neighbours.
        </Typography>

        <Box sx={{ my: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
            Why Use This Map?
          </Typography>
          <Grid container spacing={7}>
            <Grid item xs={12} sm={4}>
              <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2, height: '100%' }}>
                <Typography variant="h6" color="secondary">Free to Use</Typography>
                <Typography variant="body2">Always free for families to search and explore displays.</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2, height: '100%' }}>
                <Typography variant="h6" color="secondary">Community Verified</Typography>
                <Typography variant="body2">Users can confirm displays are active, ensuring accuracy.</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2, height: '100%' }}>
                <Typography variant="h6" color="secondary">Easy Navigation</Typography>
                <Typography variant="body2">Get directions straight to the best lights in your area.</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Typography variant="body1" paragraph>
          Have a question or suggestion? We'd love to hear from you. Visit our <Link component={RouterLink} to="/contact">Contact Page</Link> to get in touch.
        </Typography>

        {/* --- FACEBOOK FEED INTEGRATION --- */}
        <Box sx={{ mt: 6, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h5" gutterBottom>
            Follow Us on Facebook
          </Typography>
          <iframe 
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61585180973488&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="340" 
            height="500" 
            style={{ border: 'none', overflow: 'hidden' }} 
            scrolling="no" 
            frameBorder="0" 
            allowFullScreen={true} 
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            title="Christmas Lights Map Facebook Page" 
          >
          </iframe>
        </Box>
        {/* -------------------------------- */}

      </Paper>
    </Container>
  );
}

export default AboutPage;